import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import {getBrands, getInventoryEventTypes, getInventoryTypes} from "../common/api/InventoryApi";
import MDButton from "../../components/MDButton";
import {Chip, FormControlLabel, InputAdornment, NativeSelect, TextareaAutosize} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import MDInput from "../../components/MDInput";
import {CONSTANTS} from "../common/constants";
import {getCafeOptionGroups} from "../common/api/WebApi";

export default function ManageInventoryModal(props) {

  const [context, setContext] = useContext(AppContext);
  const [inventory, setInventory] = useState(props.inventory);
  const [isInventoryEvent, setIsInventoryEvent] = useState(props.isInventoryEvent);
  const [unlimited, setUnlimited] = useState(props?.inventory?.unlimited);
  const [giftCard, setGiftCard] = useState(props?.giftCard);
  const [cafeMode, setCafeMode] = useState(props?.cafeMode);
  const [addOns, setAddOns] = useState(props?.addOns);

  const inventoryLabel = props.isInventoryEvent ? 'Event' : (props?.giftCard ? 'Gift Card' : (props?.cafeMode ? 'Cafe Item' : 'Inventory'));

  const [inventoryTypes, setInventoryTypes] = useState();
  const [inventoryTypeId, setInventoryTypeId] = useState();

  const [brands, setBrands] = useState();
  const [inventoryEventTypes, setInventoryEventTypes] = useState();

  const statuses = [...CONSTANTS.STATUSES];

  const [inventoryImage, setInventoryImage] = useState(null);
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [inventoryImageName, setInventoryImageName] = useState(null);
  const [inventoryImageType, setInventoryImageType] = useState(null);
  const [validImageSize, setValidImageSize] = useState(true);

  const [backgroundImageName, setBackgroundImageName] = useState(null);
  const [backgroundImageType, setBackgroundImageType] = useState(null);
  const [validBackgroundImageSize, setValidBackgroundImageSize] = useState(true);

  const [imageSize, setImageSize] = useState(0);
  const [backgroundImageSize, setBackgroundImageSize] = useState(0);
  const [removeImage, setRemoveImage] = useState(false);
  const [removeBackgroundImage, setRemoveBackgroundImage] = useState(false);
  const [removeIndex, setRemoveIndex] = useState(1);
  const [removeBackgroundIndex, setRemoveBackgroundIndex] = useState(1);
  const [price, setPrice] = useState(props?.inventory?.price);
  const [minAmount, setMinAmount] = useState(props?.inventory?.minAmount);
  const [maxAmount, setMaxAmount] = useState(props?.inventory?.maxAmount);

  const [wholesalePrice, setWholesalePrice] = useState(props?.inventory?.wholesalePrice);

  const [preview, setPreview] = useState(null);
  const [backgroundImagePreview, setBackgroundImagePreview] = useState(null);
  const [formInvalid, setFormInvalid] = useState(false);
  const [cafeGroups, setCafeGroups] = useState([]);

  useEffect(() => {
    if (props?.inventory?.cafeGroups) {
      setCafeGroups(props?.inventory?.cafeGroups);
    }
  }, [props?.inventory?.cafeGroups]);

  const toggleUnlimited = (e) => {
    setUnlimited(e.target.checked);
  };

  const filterType = (type) => {
    if (addOns) {
      return type?.partyItem;
    } else if (cafeMode && type?.cafeItem) {
      return true;
    } else if (!cafeMode && !type?.cafeItem) {
      return true;
    }
    return false;
  }

  useEffect(() => {
    getInventoryTypes(cafeMode).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        let _none = {id: null, name: 'None'};
        let _types = [_none, ...result];
        setInventoryTypes(result);
      }
    });
    getInventoryEventTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setInventoryEventTypes(result);
      }
    });
    getBrands().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        let _none = {id: -1, name: 'None'};
        let _brands = [_none, ...result];
        setBrands(_brands);
      }
    });

  }, [props.show]);

  const [optionGroups, setOptionGroups] = useState([]);

  const getInventoryOptionGroupsFn = () => {
    getCafeOptionGroups().then((resp) => {
      let _groups = [...resp];
      let _invGroups = props?.inventory?.cafeGroups ? [...props?.inventory?.cafeGroups] : [];
      for (let k in _invGroups) {
        for (let j in _groups) {
          if (_invGroups[k].optionGroupGk === _groups[j].optionGroupGk) {
            _groups[j].sortOrder = _invGroups[k].sortOrder;
          }
        }
      }
      setOptionGroups(_groups);
    });
  }

  useEffect(() => {
    if (cafeMode) {
      getInventoryOptionGroupsFn();
    }
  }, [cafeMode]);

  useEffect(() => {
    setInventory(props?.inventory);
    setInventoryTypeId(props?.inventory?.inventoryType?.id);
  }, [props?.inventory]);

  const [isNew, setIsNew] = useState(!!!props.inventory?.guid);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(inventory)
  });

  const handleClose = () => {
    props.handleClose();
  };

  const handleSave = (data) => {
    let d = {...data};
    d.price = price;
    d.wholesalePrice = wholesalePrice;
    d.unlimited = unlimited;
    d.giftCard = giftCard;
    d.minAmount = minAmount;
    d.maxAmount = maxAmount;
    d.inventoryImage = inventoryImage;
    d.inventoryImageName = inventoryImageName;
    d.inventoryImageType = inventoryImageType;

    d.backgroundImage = backgroundImage;
    d.backgroundImageName = backgroundImageName;
    d.backgroundImageType = backgroundImageType;

    d.removeImage = removeImage;
    d.cafeGroups = cafeGroups;

    props.handleSave(d);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      setPreview(null);

      setInventoryImageName(null);
      setInventoryImageType(null);
      setInventoryImage(null);
      setValidImageSize(true);
      setImageSize(0);
      return;
    }
    setRemoveImage(false);
    setInventoryImageName(file.name);
    setInventoryImageType(file.type);
    setValidImageSize(true);

    const reader = new FileReader();

    reader.onload = function (evt) {
      setImageSize(file.size);
      setValidImageSize((file.size / 1e6).toFixed(1) < 5);
      setInventoryImage(btoa(evt.target.result));
    }
    reader.readAsBinaryString(file);
    setPreview(URL.createObjectURL(file));

    setRemoveImage(false);
  }

  const handleBackgroundFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      setBackgroundImagePreview(null);

      setBackgroundImageName(null);
      setBackgroundImageType(null);
      setBackgroundImage(null);
      setValidBackgroundImageSize(true);
      setBackgroundImageSize(0);
      return;
    }
    setRemoveBackgroundImage(false);
    setBackgroundImageName(file.name);
    setBackgroundImageType(file.type);
    setValidBackgroundImageSize(true);

    const reader = new FileReader();

    reader.onload = function (evt) {
      setBackgroundImageSize(file.size);
      setValidBackgroundImageSize((file.size / 1e6).toFixed(1) < 5);
      setBackgroundImage(btoa(evt.target.result));
    }
    reader.readAsBinaryString(file);
    setBackgroundImagePreview(URL.createObjectURL(file));

    setRemoveBackgroundImage(false);
  }

  const removePreviewImage = () => {
    setRemoveImage(true);
    setImageSize(0);
    setInventoryImage(null);
    setValidImageSize(true);
    setPreview(null);
  }

  const removeBackgroundImagePreviewImage = () => {
    setRemoveBackgroundImage(true);
    setBackgroundImageSize(0);
    setBackgroundImage(null);
    setValidBackgroundImageSize(true);
    setBackgroundImagePreview(null);
  }

  const hasInventoryGroup = (item) => {
    let _cafeGroups = [...cafeGroups];
    let cond = false;
    for (let k in _cafeGroups) {
      if (item.optionGroupGk === _cafeGroups[k].optionGroupGk) {
        cond = true;
      }
    }
    return cond;
  }

  const updateInventoryGroup = (e, item) => {
    let _cafeGroups = [...cafeGroups];
    if (e.target.checked) {
      item.selected = true;
      item.sortOrder = _cafeGroups.length + 1;
      _cafeGroups.push(item);
    } else {
      item.selected = true;
      let idx;
      for (let k in _cafeGroups) {
        if (item.optionGroupGk === _cafeGroups[k].optionGroupGk) {
          idx = k;
        }
      }
      _cafeGroups.splice(idx, 1);
    }
    setCafeGroups(_cafeGroups);
  }

  const [renderIndex, setRenderIndex] = useState(1);

  const moveUp = (item) => {
    let _obj = [...optionGroups];
    let sortOrder = 2;
    for (let i = 0; i < _obj.length; i++) {
      _obj[i].sortOrder = sortOrder;
      sortOrder+=2;
    }
    for (let i = 0; i < _obj.length; i++) {
      if (_obj[i].optionGroupGk === item.optionGroupGk) {
        _obj[i].sortOrder = _obj[i].sortOrder - 3;
      }
    }

    let _cafeGroups = [...cafeGroups];
    for (let j in _cafeGroups) {
      for (let k in optionGroups) {
        if (_cafeGroups[j].optionGroupGk === optionGroups[k].optionGroupGk) {
          _cafeGroups[j].sortOrder = optionGroups[k].sortOrder;
        }
      }
    }

    setCafeGroups(_cafeGroups);

    setOptionGroups(_obj);
    setRenderIndex(renderIndex + 1);
  }

  const moveDown = (item) => {
    let _obj = [...optionGroups];
    let sortOrder = 2;
    for (let i = 0; i < _obj.length; i++) {
      _obj[i].sortOrder = sortOrder;
      sortOrder+=2;
    }
    for (let i = 0; i < _obj.length; i++) {
      if (_obj[i].optionGroupGk === item.optionGroupGk) {
        _obj[i].sortOrder = _obj[i].sortOrder + 3;
      }
    }

    let _cafeGroups = [...cafeGroups];
    for (let j in _cafeGroups) {
      for (let k in optionGroups) {
        if (_cafeGroups[j].optionGroupGk === optionGroups[k].optionGroupGk) {
          _cafeGroups[j].sortOrder = optionGroups[k].sortOrder;
        }
      }
    }

    setCafeGroups(_cafeGroups);

    setOptionGroups(_obj);
    setRenderIndex(renderIndex + 1);
  }

  return (
    <>
      <Modal onHide={handleClose} size={cafeMode ? 'xl' : 'lg'} show={props.show}>
        <form onSubmit={handleSubmit(handleSave)} id={'inventoryForm'}>
          <Modal.Header closeButton>
            <Modal.Title>{isNew ? 'Create New' : 'Manage'} {inventoryLabel} {addOns ? 'Add-On' : ''}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col className={'col col-main'} md={cafeMode ? 8 : 12} xs={12}>
                <Container>
                  <Row>
                    <Col className={'col'} sm={12} xs={12}>
                      <div className="form-group">
                        <MDInput type="text" required
                                 InputLabelProps={{shrink: true}}
                                 autoComplete={'off'}
                                 {...register('name')}
                                 autoComplete="off"
                                 placeholder={inventoryLabel + ' Name'}
                                 className="form-control" id="name"
                                 label={'Enter ' + inventoryLabel + ' Name'}/>
                      </div>
                    </Col>
                  </Row>

                  {giftCard && <>
                    <Row className={'mt-4'}>
                      <Col className={'col'} sm={6} xs={12}>
                        <MDInput type="text" step="0.01" required
                                 {...register('minAmount', {
                                   valueAsDouble: true
                                 })}
                                 onChange={(e) => {
                                   let v = e.target.value.replace(/[^0-9.]/g, '');
                                   e.target.value = v;
                                   setMinAmount(v);
                                 }}
                                 InputProps={{
                                   startAdornment: <InputAdornment position="start">
                                     <span className={'fa fa-dollar'}></span>
                                   </InputAdornment>,
                                 }}
                                 placeholder={"10.00"}
                                 autoComplete="off"
                                 className="form-control" id="minAmount"
                                 label="Minimum Amount"/>
                      </Col>
                      <Col className={'col'} sm={6} xs={12}>
                        <div className={'input-group'}>
                          <MDInput type="text" step="0.01" required
                                   {...register('maxAmount', {
                                     valueAsDouble: true
                                   })}
                                   onChange={(e) => {
                                     let v = e.target.value.replace(/[^0-9.]/g, '');
                                     e.target.value = v;
                                     setMaxAmount(v);
                                   }}
                                   InputProps={{
                                     startAdornment: <InputAdornment position="start">
                                       <span className={'fa fa-dollar'}></span>
                                     </InputAdornment>,
                                   }}
                                   placeholder={"100.00"}
                                   autoComplete="off"
                                   className="form-control" id="maxAmount"
                                   label="Maximum Amount"/>
                        </div>
                      </Col>
                    </Row>
                  </>}

                  <Row className={'mt-4'}>
                    <Col className={'col'} sm={6} xs={12}>
                      <div className="form-group">
                        <div className={'input-group'}>
                          <MDInput type="number" step="1" required={!unlimited}
                                   {...register('quantity', {
                                     valueAsNumber: true,
                                   })}
                                   disabled={unlimited}
                                   defaultValue={'0'}
                                   autoComplete="off"
                                   className="form-control" id="quantity"
                                   label="Quantity"/>
                        </div>
                      </div>

                      <div className="form-group">
                        <div className={'input-group'}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                defaultChecked={props?.inventory?.unlimited}
                                {...register('unlimited')}
                                onChange={(e) => {
                                  toggleUnlimited(e);
                                }} name="unlimited"/>
                            }
                            label="Unlimited Available"
                          />
                        </div>
                      </div>

                    </Col>
                    <Col className={'col'} sm={6} xs={12}>
                      <div className="form-group native-margin-fix">
                        <label htmlFor="ageRange" className={"native-label"}>Status</label>
                        {statuses?.length && <NativeSelect
                          variant="outlined"
                          required
                          id={'status'} name={'status'} className={'form-control'}
                          {...register('status.id', {
                            valueAsNumber: true
                          })} >
                          {
                            statuses?.map((c) =>
                              <option value={c.id} key={c.id}>
                                {c.name}
                              </option>)
                          }
                        </NativeSelect>}
                      </div>


                    </Col>
                  </Row>

                  {!giftCard && <>
                    <Row className={'mt-4'}>
                      <Col className={'col'} sm={6} xs={12}>
                        <div className="form-group">
                          <div className={'input-group'}>
                            <MDInput type="text" step="0.01" required
                                     {...register('price', {
                                       valueAsDouble: true
                                     })}
                                     onChange={(e) => {
                                       let v = e.target.value.replace(/[^0-9.]/g, '');
                                       e.target.value = v;
                                       setPrice(v);
                                     }}
                                     InputProps={{
                                       startAdornment: <InputAdornment position="start">
                                         <span className={'fa fa-dollar'}></span>
                                       </InputAdornment>,
                                     }}
                                     defaultValue={'0.00'}
                                     autoComplete="off"
                                     className="form-control" id="price"
                                     label="Price"/>
                          </div>
                        </div>
                      </Col>
                      <Col className={'col'} sm={6} xs={12}>
                        <div className="form-group">
                          <div className={'input-group'}>
                            <MDInput type="text" step="0.01"
                                     {...register('wholesalePrice', {
                                       // valueAsNumber: true,
                                       valueAsDouble: true
                                     })}
                                     onChange={(e) => {
                                       let v = e.target.value.replace(/[^0-9.]/g, '');
                                       e.target.value = v;
                                       setWholesalePrice(v);
                                     }}
                                     InputProps={{
                                       startAdornment: <InputAdornment position="start">
                                         <span className={'fa fa-dollar'}></span>
                                       </InputAdornment>,
                                     }}
                                     min={0}
                                     defaultValue={'0.00'}
                                     autoComplete="off"
                                     className="form-control" id="wholesalePrice"
                                     label="Wholesale Price"/>
                          </div>
                        </div>


                      </Col>
                    </Row>
                  </>
                  }

                  <Row className={'mt-2'}>
                    <Col className={'col'} sm={6} xs={12}>
                      <div className="form-group">

                        <label htmlFor="inventoryType">Inventory Type</label>
                        {inventoryTypes?.length && <NativeSelect
                          variant="outlined"
                          required
                          id={'inventoryType'} name={'inventoryType'} className={'form-control'}
                          {...register('inventoryType.id', {
                            valueAsNumber: true,
                            onChange: (e) => {
                              setInventoryTypeId(parseInt(e.target.value, 10))
                            }
                          })} >
                          {
                            inventoryTypes?.filter((type) => filterType(type)).map((c) =>
                              <option value={c.id} key={c.id}>
                                {c.name}
                              </option>)
                          }
                        </NativeSelect>}
                      </div>

                      <div className="form-group mt-2">
                        <label htmlFor="brand">Brand</label>
                        {brands?.length && <NativeSelect
                          variant="outlined"
                          required
                          id={'brand'} name={'brand'} className={'form-control'}
                          {...register('brand.id', {
                            valueAsNumber: true
                          })} >
                          {
                            brands?.map((c) =>
                              <option value={c.id} key={c.id}>
                                {c.name}
                              </option>)
                          }
                        </NativeSelect>}
                      </div>
                    </Col>


                    <Col className={'col'} sm={6} xs={12}>
                      <div className="form-group">
                        <label htmlFor="inventoryImage">{inventoryLabel} Image</label>
                        <input type="file"
                               accept="image/*"
                               {...register('inventoryImage', {
                                 onChange: (e) => {
                                   handleFileChange(e);
                                 }
                               })}
                               autoComplete="off"
                               className="form-control" id="inventoryImage"/>
                        <div className={"clear clearfix"}>
                          <p className={!validImageSize ? 'pt-2 text-danger' : 'pt-2 fw-light'}>Maximum image size 5Mb
                            {!validImageSize ? ' Exceeded' : ''}</p>
                        </div>

                        {preview && <>
                          <img className={'mt-2 img-thumbnail'} src={preview} alt="img"/>
                          <Chip label="Remove"
                                style={{
                                  background: '#fff'
                                }}
                                className={'cls clear-both remove-button cursor-default'}
                                variant="outlined" onClick={() => {
                            setInventoryImage(null);
                            setValidImageSize(true);
                            removePreviewImage();
                          }}/>
                        </>}
                        {!preview && inventory?.imageUrl && removeIndex > 0 &&
                          <><img className={'mt-2 img-thumbnail'} src={inventory.imageUrl} alt="img"/>
                            <div>
                              <Chip label="Remove"
                                    style={{
                                      background: '#fff'
                                    }}
                                    className={'cls clear-both remove-button cursor-default'}
                                    variant="outlined" onClick={() => {
                                setInventoryImage(null);
                                setValidImageSize(true);
                                setRemoveIndex(0);
                                removePreviewImage();
                              }}/>
                            </div>
                          </>}

                      </div>



                      {props?.giftCard && <>
                        <div className="form-group cls clear-both d-block mt-2">
                          <label htmlFor="backgroundImage">Background Image</label>
                          <input type="file"
                                 accept="image/*"
                                 {...register('backgroundImage', {
                                   onChange: (e) => {
                                     handleBackgroundFileChange(e);
                                   }
                                 })}
                                 autoComplete="off"
                                 className="form-control" id="backgroundImage"/>
                          <div className={"clear clearfix"}>
                            <p className={!validBackgroundImageSize ? 'pt-2 text-danger' : 'pt-2 fw-light'}>Maximum image size 5Mb
                              {!validBackgroundImageSize ? ' Exceeded' : ''}</p>
                          </div>

                          {backgroundImagePreview && <>
                            <img className={'mt-2 img-thumbnail'} src={backgroundImagePreview} alt="img"/>
                            <Chip label="Remove"
                                  style={{
                                    background: '#fff'
                                  }}
                                  className={'cls clear-both remove-button cursor-default'}
                                  variant="outlined" onClick={() => {
                              setBackgroundImageSize(null);
                              setValidBackgroundImageSize(true);
                              removeBackgroundImagePreviewImage();
                            }}/>
                          </>}
                          {!backgroundImagePreview && inventory?.backgroundImageUrl && removeBackgroundIndex > 0 &&
                            <><img className={'mt-2 img-thumbnail'} src={inventory.backgroundImageUrl} alt="img"/>
                              <div>
                                <Chip label="Remove"
                                      style={{
                                        background: '#fff'
                                      }}
                                      className={'cls clear-both remove-button cursor-default'}
                                      variant="outlined" onClick={() => {
                                  setBackgroundImage(null);
                                  setValidBackgroundImageSize(true);
                                  setRemoveBackgroundIndex(0);
                                  removeBackgroundImagePreviewImage();
                                }}/>
                              </div>
                            </>}

                        </div>

                      </>}
                    </Col>

                  </Row>

                  <Row className={'mt-2'}>
                    <Col className={'col'} sm={12} xs={12}>
                      <div className="form-group">
                        <label htmlFor="name">{inventoryLabel} Description</label>
                        <TextareaAutosize
                          {...register('desc')}
                          autoComplete="off"
                          maxLength={4000}
                          minRows={3}
                          className="form-control" id="desc"
                          placeholder={'Enter ' + inventoryLabel + ' Description'}/>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </Col>
              {cafeMode && <>
                <Col className={'col col-main'} xs={12} md={4} style={{
                  borderLeft: 'solid 2px #ddd',
                  position: 'relative',
                }}>
                  <div style={{
                    position: 'sticky',
                    top: 0
                  }}>
                    <h5>Cafe Options</h5>
                    {optionGroups?.filter(group => group?.inventoryType?.id == -1 || group?.inventoryType?.id === inventoryTypeId).length > 0 && <>
                      <table>
                        <tbody>
                        {optionGroups?.sort((a, b) => {
                          if (hasInventoryGroup(a) !== hasInventoryGroup(b)) {
                            return hasInventoryGroup(a) ? -1 : 1
                          }
                          return a.sortOrder - b.sortOrder;
                        })?.filter(group =>  group?.inventoryType?.id == -1 || group?.inventoryType?.id === inventoryTypeId)?.map((group, idx) => {
                          return (
                            <tr key={idx}>
                              <td><label><Checkbox
                                checked={hasInventoryGroup(group)}
                                onChange={(e) => {
                                  updateInventoryGroup(e, group)
                                }}
                              /><b>{group.optionGroupName}</b>
                              </label>
                                <span style={{
                                  display: 'block',
                                  paddingLeft: '45px',
                                  marginTop: '-10px'
                                }}>
                                  <small>
                                    {group.options?.sort((a, b) => a.sortOrder - b.sortOrder)?.map((opt, idx) => {
                                      return <span key={idx}>{idx === 0 ? '' : ', '}{opt.optionName}</span>
                                    })}
                                  </small>
                                </span>
                              </td>

                              <td width={"5%"}>
                                {renderIndex && hasInventoryGroup(group) && <>
                                  <a color="primary"
                                     disabled={idx === 0}
                                     className="pull-right d-block clear clearfix mx-1"
                                     size="small"
                                     href={'#'}
                                     onClick={(e) => {
                                       e.preventDefault();
                                       moveUp(group);
                                     }}>
                                                       <span
                                                         style={{
                                                           fontSize: '14px'
                                                         }}
                                                         className={'fa fa-arrow-circle-up'}></span>
                                  </a>

                                  <div style={{
                                    width: '100%',
                                    clear: 'both',
                                    height: '4px',
                                    display: 'block'
                                  }}></div>
                                  <a color="primary"
                                     href={'#'}
                                     disabled={idx === cafeGroups.length - 1}
                                     className="pull-right d-block clear clearfix mx-1"
                                     size="small"
                                     onClick={(e) => {
                                       e.preventDefault();
                                       moveDown(group);
                                     }}>
                                              <span
                                                style={{
                                                  fontSize: '14px'
                                                }}
                                                className={'fa fa-arrow-circle-down'}></span>
                                  </a>
                                </>
                                }


                              </td>
                            </tr>
                          )
                        })
                        }

                        </tbody>
                      </table>

                    </>
                    }

                  </div>
                </Col>
              </>}

            </Row>

          </Modal.Body>
          <Modal.Footer>
            <MDButton type="submit" color="info" disabled={formInvalid || props.saving}>
              {props.saving ? 'Saving...' : 'Save'}
            </MDButton>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
}